import { Outlet } from "react-router-dom";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import OrdersSidebar from "../components/OrdersSidebar";

const OrdersListWrapper = () => {
    return (
        <div className="flex flex-grow flex-col 3xl:pt-4 4xl:px-10 animate-slide-down">
            <div className="page-container flex h-[calc(100vh-110px)] w-full flex-col flex-nowrap lg:flex-row">
                <div className="sidebar w-full overflow-hidden lg:w-[20vw] lg:shrink-0">
                    <OrdersSidebar />
                </div>
                <div className="content h-full w-full min-w-0 flex-1 p-4 pt-0">
                    <FiltersProvider>
                        <Outlet />
                    </FiltersProvider>
                </div>
            </div>
        </div>
    );
}

export default OrdersListWrapper;
